import session from 'frontend/shared/javascripts/util/session'

class RegistrationSteps {
  private subjectAreaIdAndKeyByStudyCourseId: Record<string, string> | undefined

  configureSubjectAreaMapping(subjectAreaIdAndKeyByStudyCourseId: Record<string, string>): void {
    this.subjectAreaIdAndKeyByStudyCourseId = subjectAreaIdAndKeyByStudyCourseId
  }

  onSave(stepName: string, params: Record<string, string>): void {
    const smartParams = new SmartParams(params)
    switch (stepName) {
      case 'study_info':
        this.saveStudyInfo(smartParams)
        // We need to set the last completed step because there is actually no user.
        // In all other steps, this field will be set through the compiler sync_session_data.js
        session.lastCompletedStep = stepName
        break
      case 'registration':
        break
      case 'personal_info':
        this.savePersonalInfo(smartParams)
        break
      case 'from_authentication_provider':
        this.saveStudyInfo(smartParams)
        break
    }
  }

  saveStudyInfo(smartParams: SmartParams): void {
    session.educationLevel = smartParams.get('education_level') ?? null
    switch (session.educationLevel) {
      case 'student':
        session.universityIdAndKey = smartParams.get('university_id')
        session.studyCourseIdAndKey = smartParams.get('study_course_id')
        session.studyStart = smartParams.get('study_start') ?? null

        if (this.subjectAreaIdAndKeyByStudyCourseId) {
          session.subjectAreaIdAndKey =
            this.subjectAreaIdAndKeyByStudyCourseId[session.studyCourseId!]
        }
        break
      case 'parent':
        session.schoolRegion = smartParams.get('parents_school_region') ?? null
        session.schoolName = smartParams.get('parents_school_name') ?? null
        session.schoolGrade = smartParams.get('parents_school_grade') ?? null
        session.schoolZipcode = smartParams.get('parents_school_zipcode') ?? null
        break
      case 'pupil':
        session.schoolRegion = smartParams.get('pupils_school_region') ?? null
        session.schoolName = smartParams.get('pupils_school_name') ?? null
        session.schoolGrade = smartParams.get('pupils_school_grade') ?? null
        session.schoolZipcode = smartParams.get('pupils_school_zipcode') ?? null
        break
      case 'teacher':
        session.schoolRegion = smartParams.get('teachers_school_region') ?? null
        session.schoolName = smartParams.get('teachers_school_name') ?? null
        session.schoolZipcode = smartParams.get('teachers_school_zipcode') ?? null
        break
    }
  }

  savePersonalInfo(smartParams: SmartParams): void {
    session.gender = smartParams.get('gender') ?? null
  }
}

class SmartParams {
  private params: Record<string, string>

  constructor(params: Record<string, string>) {
    this.params = params
  }

  // Allows to retrieve a param key like "user[foo]" by just .get("foo")
  get(attributeName: string): string | undefined {
    for (const [key, value] of Object.entries(this.params)) {
      if (key.includes(`[${attributeName}]`)) return value
    }
  }
}

const registrationSteps = new RegistrationSteps()
export default registrationSteps
